import { getAchievementRequest } from "../repositories/achievement_repository";
export const AchievementService = () => {
    const fetchAchievement = async (setAchievementData) => {
        try{
            const response = await getAchievementRequest();

            if (response?.success) {
                setAchievementData(response.data);
            }
        }
        catch (error) {
            console.error("Failed to fetch achievement data.");
        }
    };
    return {
        fetchAchievement,
    };
};